import { useMutation } from "@tanstack/react-query"
import {
  scheduleStudentIntake,
  removeStudentFromIntake,
  registerStudentAbsentForEvent,
} from "../services/intake"
import { Intake, ModalType } from "../types"

export const useScheduleIntakeMutation = () => {
  return useMutation({
    mutationFn: scheduleStudentIntake,
  })
}

export const useRemoveStudentFromIntakeMutation = ({
  intakeId,
}: {
  intakeId: Intake["id"]
}) => {
  return useMutation({
    mutationFn: () => removeStudentFromIntake(intakeId),
  })
}

export const useRegisterStudentAbsentForEventMutation = ({
  entityType,
  entityId,
}: {
  entityType: ModalType
  entityId: string
}) => {
  return useMutation({
    mutationFn: (data: { absenceReason: string; reasonOther?: string }) =>
      registerStudentAbsentForEvent({
        entityType,
        entityId,
        ...data,
      }),
  })
}
